var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMinusBig = function SvgMinusBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 10,
    viewBox: "0 0 16 2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.19 0c.45-.004.813.432.81.97-.003.54-.37.98-.82.983H7.232L.81 2c-.45.004-.813-.432-.81-.97C.003.49.37.05.82.047L7.139 0h8.05z"
  })));
};

export default SvgMinusBig;